import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations } from './translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem('lang') || 'en');

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem('lang', l);
    if (typeof document !== 'undefined') {
      document.documentElement.lang = l;
    }
  }, []);

  const t = useCallback((key, fallback) => {
    const dict = translations[lang] || translations.en;
    return dict[key] ?? translations.en[key] ?? fallback ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    // Safe fallback if provider is missing
    return { lang: 'en', setLang: () => {}, t: (k, f) => (translations.en[k] ?? f ?? k) };
  }
  return ctx;
};
